<template lang="pug">
  .auth--confirm
    img.auth__logo(:alt="appName" :src="logoPath")

    p(v-html="$t('oauth.title', { service: getServiceName()})")

    //- img.application__logo(
    //-   :alt="service"
    //-   :src="getAppLogo()")

    //- h2 {{ $t('oauth.subtitle') }}

    ul.listScopes
      li
        .listScopes__title
          span(v-html="$t('oauth.scope', { app: appName })")
          i.van-icon.van-icon-more(:class="{'open': showDescription}" @click="toggleDescription")

        .description(:class="{'open': showDescription}")
          hr

          | {{ $t('oauth.description.intro') }}

          ul
            li {{ $t('oauth.description.list1', { service: getServiceName(), app: appName, device: deviceType}) }}
            li {{ $t('oauth.description.list2', { service: getServiceName(), app: appName, device: deviceType }) }}
              ul
                li {{ $t('oauth.description.list21') }}
                li {{ $t('oauth.description.list22') }}
            li {{ $t('oauth.description.list3', { service: getServiceName(), app: appName }) }}

    .links
      a.link(v-if="certPrivacy" :href="certPrivacy" target="_blank") {{ $t('oauth.privacy') }}
      a.link(v-if="certTerms" :href="certTerms" target="_blank") {{ $t('oauth.term') }}

    hr.no-padding-top.margin-bottom

    //- Submit button
    van-button(
      size="large"
      type="primary"
      @click="$emit('authorize')") {{ $t('oauth.allow') }}

    a.cancel(@click="cancel") {{ $t('oauth.cancel') }}
</template>

<script>
import axios from "axios";
import i18n from "@/i18n";
import router from "@/router";
import { PROYECT } from "@/constant";

export default {
  data() {
    return {
      appName: PROYECT.NAME,
      deviceType: PROYECT.DEVICE,
      logoPath: `/${PROYECT.LOGO}.svg`,
      showDescription: false,
      certPrivacy: null,
      certTerms: null
    };
  },
  props: {
    serviceId: {
      type: String,
      default: ""
    }
  },
  methods: {
    getAppLogo() {
      return `/${this.service}.png`;
    },

    getServiceName() {
      switch (this.serviceId) {
        case "ALEXA":
          return "Alexa";
        case "GOOGLE":
          return "Google";
        case "IFTTT":
          return "Ifttt";
        case "OPENAPI":
          return "Openapi";
        default:
          return "";
      }
    },

    /* prettier-ignore */
    getCertPrivacy(language, service) {
      switch (service) {
        case 'ALEXA':
          return PROYECT.ALEXA.PRIVACY[language] || PROYECT.ALEXA.PRIVACY.ES;
        case 'GOOGLE':
          return PROYECT.GOOGLE.PRIVACY[language] || PROYECT.GOOGLE.PRIVACY.ES;
        default:
          return '';
      }
    },

    /* prettier-ignore */
    getCertTerms(language, service) {
      switch (service) {
        case 'ALEXA':
          return PROYECT.ALEXA.TERMS[language] || PROYECT.ALEXA.TERMS.ES;
        case 'GOOGLE':
          return PROYECT.GOOGLE.TERMS[language] || PROYECT.GOOGLE.TERMS.ES;
        default:
          return '';
      }
    },

    toggleDescription() {
      this.showDescription = !this.showDescription;
    },

    cancel() {
      window.localStorage.removeItem("token");
      axios.defaults.headers.common.Authorization = "";
      router.push({ name: "home" });
    }
  },
  created() {
    const language = i18n.locale.toUpperCase();
    this.certPrivacy = this.getCertPrivacy(language, this.serviceId);
    this.certTerms = this.getCertTerms(language, this.serviceId);
  }
};
</script>

<style lang="scss" scoped>
h1 {
  @include fontsize(eta);

  margin-bottom: $space;
  text-align: center;
}

h2 {
  @include fontsize(theta);

  margin-bottom: halve($space);
  text-align: center;
}

strong {
  @include fontsize(theta);

  display: block;
  padding-top: 0.2rem;
  line-height: 1.1rem;
  color: gray(gray1);
}

hr {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, #f1f2f2 50%);
}

.application__logo {
  display: block;
  height: 30px;
  margin: double($space) auto;
}

.listScopes {
  @include fontsize(iota);

  line-height: 1.1rem;
  background-color: gray(gray6);
  border-radius: $border-radius;

  .listScopes__title {
    position: relative;
    padding-right: double($space) !important;
  }

  li {
    padding: halve($space) halve($space);
    margin: 0;
  }

  .van-icon {
    position: absolute;
    top: quarter(-$space);
    right: quarter(-$space);
    width: double($space);
    height: double($space);
    margin: 0;
    font-size: 16px;
    line-height: double($space);
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;

    &.open {
      transform: rotate(45deg);
    }
  }
}

.van-button {
  cursor: pointer;
}

.description {
  @include fontsize(iota);

  max-height: 0;
  overflow: hidden;
  line-height: 1.1rem;
  user-select: none;
  transition: all 0.3s;

  &.open {
    max-height: 500px;
  }

  > ul {
    margin-bottom: 0;
  }

  li {
    padding-left: 0;
    margin-left: 1rem;
    list-style: disc;

    ul li {
      padding-bottom: 0;
    }

    ul li:not(:first-of-type) {
      padding-top: quarter($space);
    }
  }

  hr {
    padding: quarter($space) 0 $space;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, $border-color 50%);
  }
}

.link {
  @include fontsize(theta);

  color: brand();
  text-decoration: underline;

  &:last-of-type {
    float: right;
  }
}

.cancel {
  @include fontsize(eta);

  display: block;
  margin-top: 1.6rem;
  font-size: 0.95rem;
  color: gray(gray1);
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
}
</style>
